import {
  arbFactories,
  arbFarm,
  arbFarmAction,
  goerFactories,
  goerFarm,
  goerFarmAction,
} from "./internalAddresses";
import { SupportedChainId } from "./chains";
import { uniToken, usdcToken } from "./tokens";
import usdc from "../../images/usdc.png";
import uni from "../../images/uni.png";
import { ALL_TOKENS } from "./externalAddresses";

const ARBITRUM_FARM = {
  ...usdcToken,
  tokenIcon: usdc,
  tokenAddress: ALL_TOKENS[SupportedChainId.ARBITRUM_ONE].USDC,
  deployedChainId: SupportedChainId.ARBITRUM_ONE,
  farmAddress: arbFarm,
  factoryAddress: arbFactories.WETH_USDC,
  farmActionAddress: arbFarmAction,
};

const GOERLI_FARM = {
  ...uniToken,
  tokenIcon: uni,
  tokenAddress: ALL_TOKENS[SupportedChainId.GOERLI].UNI,
  deployedChainId: SupportedChainId.GOERLI,
  farmAddress: goerFarm,
  factoryAddress: goerFactories.WETH_UNI,
  farmActionAddress: goerFarmAction,
};

export const ALL_FARMS: { [key: number]: FarmProps } = {
  [SupportedChainId.ARBITRUM_ONE]: ARBITRUM_FARM,
  [SupportedChainId.GOERLI]: GOERLI_FARM,
};

export const ALL_FARM_ACTIONS: { [key: number]: string } = {
  [SupportedChainId.ARBITRUM_ONE]: arbFarmAction,
  [SupportedChainId.GOERLI]: goerFarmAction,
};

export type FarmProps = {
  tokenSymbol: string;
  tokenFullName: string;
  tokenDecimal: number;
  tokenAddress: string;
  tokenIcon: string;
  deployedChainId: number;
  farmAddress: string;
  factoryAddress: string;
  farmActionAddress: string;
};
